import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { GetStartedAndContactSection } from '../GetStartedAndContactSection';

const Wrapper = styled('div', {
  display: 'flex',
  marginBottom: '44px',
  marginTop: '69px',
  '@screen >= $xs': {
    display: 'block',
  },
});

const FirstContainerTitle = styled('h1', {
  color: 'rgb(0, 38, 119)',
  fontSize: '36px ! important',
  fontWeight: '600',
  lineHeight: '40px',
  '@screen >= $xs': {
    marginBottom: '16px',
  },
});

const ContainerDescription = styled('p', {
  color: 'rgb(51, 51, 51)',
  fontSize: '15px',
  fontWeight: '400',
  letterSpacing: '0px',
  lineHeight: '24px',
  marginBottom: '28px',
});

export const IntroSection = () => {
  return (
    <Wrapper>
      <div>
        <FirstContainerTitle>
          Get started with Application Programming Interfaces (APIs)
        </FirstContainerTitle>
        <ContainerDescription>
          APIs are a modern digital tool in health care, enabling timely and
          efficient data sharing with professionals and external organizations.
          They’re not exclusive to UnitedHealthcare—APIs are standard
          programming interfaces that connect multiple applications. They
          deliver real-time data and can automate recurring data feeds.
        </ContainerDescription>
      </div>
      <GetStartedAndContactSection />
    </Wrapper>
  );
};
